import { render, staticRenderFns } from "./app-navbar.vue?vue&type=template&id=0fd168b2&"
import script from "./app-navbar.component.ts?vue&type=script&lang=ts&"
export * from "./app-navbar.component.ts?vue&type=script&lang=ts&"
import style0 from "./app-navbar.vue?vue&type=style&index=0&id=0fd168b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports